export function nextAsset(src: string): string {
  return `/statics/${src}`;
}
